import { Module } from "vuex";

import { InvitesApi } from "@/api/invites";
import { RootState } from "@/types";

interface DerrivedInvite {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}
interface InvitesState {
  invite: DerrivedInvite | null;
  invites: DerrivedInvite[];
}

export const invites: Module<InvitesState, RootState> = {
  namespaced: true,
  state: {
    invite: {
      id: "",
      email: "",
      firstName: "",
      lastName: "",
    },
    invites: [],
  },
  mutations: {
    setInvite(state, payload) {
      state.invite = payload;
    },
    setInvites(state, payload) {
      state.invites = payload;
    },
  },
  actions: {
    async sendInvite(ctx, invite) {
      await InvitesApi.sendInvite(invite);
    },
    async importPatients(ctx, file) {
      const data = new FormData();
      data.append("file", file);
      return await InvitesApi.importPatients(data);
    },
    async getInvite(ctx, id) {
      const invite = await InvitesApi.getInvite(id);
      if (!invite) {
        throw new Error("Invite doesn't exist");
      }
      ctx.commit("setInvite", invite);
    },
    async getAllInvites(ctx) {
      const invitesList = await InvitesApi.getAll();
      ctx.commit("setInvites", invitesList);
    },
    async deleteInvitation({ commit, state }, id) {
      await InvitesApi.deleteById(id);
      commit(
        "setInvites",
        state.invites.filter((inv) => inv.id !== id),
      );
    },
    resendInvite(ctx, invite) {
      InvitesApi.resendInvite(invite);
    },
  },
  getters: {
    invite(state) {
      return state.invite;
    },
    invites(state) {
      return state.invites;
    },
  },
};
